import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const PageStyles = styled(OnboardingPage)`
  padding-bottom: 18px;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(/assets/layout-own-ai-dominate/welcome/glowing-overlay.png)
      no-repeat center center / cover;
    z-index: -1;
    pointer-events: none;
  }

  .local-title {
    margin: 20px auto 40px;
  }
`;
